export default __webpack_public_path__ + "static/media/(44).d00e26da.jpg";